export const logoDefaults = {
    title: "Logo",
    alt: "Logo",
};
export default logoDefaults;
